import { api, extractJsonObject } from "./api";

/** Use localStorage like Android SharedPreferences */
const KEY = "expert_session";

export function getSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSession(sessionObj) {
  localStorage.setItem(KEY, JSON.stringify(sessionObj));

  // 🔔 notify App to re-read session
  window.dispatchEvent(new Event("authchange"));
}

export function clearSession() {
  localStorage.removeItem(KEY);

  // optional: if you store selected kendra etc, clear them too
  localStorage.removeItem("selected_kendra");
  localStorage.removeItem("kendra_list");

  // 🔔 notify App to re-read session
  window.dispatchEvent(new Event("authchange"));
}

/** Same as Android loginmd.php (FormUrlEncoded POST) */
export async function loginWithApi(mobno, pass) {
  const body = new URLSearchParams();
  body.append("mobno", mobno);
  body.append("pass", pass);

  const resp = await api.post("loginmd.php", body, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  let json;

  if (typeof resp.data === "object") {
    json = resp.data;
  } else {
    const cleaned = extractJsonObject(resp.data);
    try {
      json = JSON.parse(cleaned);
    } catch {
      throw new Error("SERVER_PARSE_ERROR");
    }
  }

  if (!json?.ok) throw new Error("INVALID_CREDENTIALS");

  const session = {
    logged_in: true,
    login_at: Date.now(),
    mobno,
    pass_login: pass,
    user: json.user || {},
    kendra: json.kendra || [],
  };

  setSession(session);
  return session;
}
